"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TaxDocumentDeliveryMethodCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Button_1 = __importDefault(require("../components/Button"));
const Taxes_1 = __importDefault(require("../api/Taxes"));
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const PlatformModal_1 = __importDefault(require("../components/PlatformModal"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const react_i18next_1 = require("react-i18next");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const Helper_1 = require("../Helper");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        row: {
            flexDirection: "row",
            alignItems: "stretch",
            paddingVertical: 18,
        },
        iconColumn: {
            width: 44,
            alignItems: "center",
            justifyContent: "center",
        },
        contentColumn: {
            flex: 1,
            paddingHorizontal: 12,
            justifyContent: "center",
        },
        description: {
            color: THEME.Text,
            fontSize: 13,
        },
        divider: {
            height: 1,
            backgroundColor: THEME.CardBorder,
            marginVertical: 4,
        },
        rowTitleContainer: {
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 4,
        },
        rowTitle: {
            color: THEME.Text,
            fontSize: 14,
            fontWeight: "600",
        },
        enrolledBadge: {
            marginLeft: 8,
            paddingHorizontal: 6,
            paddingVertical: 2,
            borderRadius: 4,
            backgroundColor: THEME.Secondary,
            flexDirection: "row",
            alignItems: "center",
        },
        enrolledBadgeText: {
            color: THEME.White,
            fontSize: 10,
            fontWeight: "700",
        },
        paperBadge: {
            marginLeft: 8,
            paddingHorizontal: 6,
            paddingVertical: 2,
            borderRadius: 4,
            backgroundColor: THEME.SmokeWhite,
            flexDirection: "row",
            alignItems: "center",
        },
        paperBadgeText: {
            color: THEME.SmokeWhiteText,
            fontSize: 10,
            fontWeight: "700",
        },
        actionColumn: {
            alignItems: "center",
            justifyContent: "center",
        },
        modalCard: {
            width: "100%",
            maxWidth: react_native_1.Platform.OS === 'web' ? 560 : '100%',
            backgroundColor: THEME.CardBackground,
            paddingHorizontal: 0,
        },
        modalHeader: {
            width: "100%",
            marginBottom: size === "sm" ? 4 : 5,
        },
        modalRow: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            paddingVertical: size === "sm" ? 8 : 10,
        },
        modalActions: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: size === "sm" ? 10 : 12,
            marginBottom: react_native_1.Platform.OS === "web" ? 0 : 16,
            width: "100%",
        },
        modalRowLeft: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            flex: 1,
            paddingRight: size === "sm" ? 16 : 32,
        },
        radioColumn: {
            width: size === "sm" ? 170 : 220,
            justifyContent: "center",
        },
        modalIconColumn: {
            width: size === "sm" ? 30 : 48,
            alignItems: "center",
            justifyContent: "center",
            marginRight: size === "sm" ? 8 : 16,
        },
        modalRowLabel: {
            color: THEME.Text,
            fontSize: size === "sm" ? 15 : 18,
            fontWeight: "600",
            flexShrink: 1,
        },
        modalDivider: {
            height: 1,
            backgroundColor: THEME.CardBorder,
            marginVertical: size === "sm" ? 2 : 4,
        },
        modalButtonSpacer: {
            width: 12,
        },
        modalActionButton: {
            flex: 1,
        },
        preferenceToggle: {
            borderColor: THEME.CardBorder,
            borderWidth: 1,
            borderRadius: 4,
            padding: 2,
            flexDirection: "row",
            gap: 2,
            // @ts-ignore
            userSelect: "none",
        },
        preferenceToggleOption: {
            flex: 1,
            paddingVertical: size === "sm" ? 8 : 9,
            paddingHorizontal: size === "sm" ? 6 : 8,
            borderRadius: 3,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
        },
        preferenceToggleText: {
            textAlign: "center",
            fontSize: size !== "sm" ? 14 : 13,
            fontWeight: "500",
        },
    });
};
function DeliveryRow(props) {
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const icon = props.isElectronic ? Theme_1.ICONS.Solid.Desktop : Theme_1.ICONS.Solid.File;
    const iconColor = props.isElectronic ? THEME.Secondary : THEME.TextDisabled;
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.row, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconColumn, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, size: size === "sm" ? 26 : 34, color: iconColor }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.contentColumn, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.rowTitleContainer, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: styles.rowTitle, children: props.label }), props.isElectronic ? ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.enrolledBadge, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: styles.enrolledBadgeText, children: t("myPay:text.enrolledInPaperless") }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Check, size: 9, color: THEME.White, style: { marginLeft: 4 } })] })) : ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.paperBadge, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: styles.paperBadgeText, children: t("myPay:text.enrolledInPaper") }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 9, color: THEME.Red, style: { marginLeft: 4 } })] }))] }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: styles.description, children: props.isElectronic
                            ? props.descriptionWhenElectronic
                            : props.descriptionWhenPaper })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.actionColumn, children: !props.isElectronic && ((0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", text: props.acceptText, textSize: 14, disabled: props.busy, onPress: props.onAcceptElectronic })) })] }));
}
function PreferenceToggle(props) {
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.preferenceToggle, children: [(0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: props.disabled, onPress: () => props.onChange(false), style: [styles.preferenceToggleOption,
                    {
                        backgroundColor: !props.value
                            ? THEME.Primary
                            : THEME.CardBackground,
                    },
                ], children: (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: [styles.preferenceToggleText, { color: !props.value ? THEME.CardBackground : THEME.Text }], children: t("myPay:text.paperMail") }) }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: props.disabled, onPress: () => props.onChange(true), style: [
                    styles.preferenceToggleOption,
                    {
                        backgroundColor: props.value
                            ? THEME.Primary
                            : THEME.CardBackground,
                    },
                ], children: (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: [styles.preferenceToggleText, { color: props.value ? THEME.CardBackground : THEME.Text }], children: t("myPay:text.electronicPaperless") }) })] }));
}
function PreferenceModalRow(props) {
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const icon = props.value ? Theme_1.ICONS.Solid.Desktop : Theme_1.ICONS.Solid.File;
    const label = props.label;
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.modalRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.modalRowLeft, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalIconColumn, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, size: size === "sm" ? 24 : 34, color: THEME.Text }) }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: styles.modalRowLabel, children: label })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.radioColumn, children: (0, jsx_runtime_1.jsx)(PreferenceToggle, { value: props.value, onChange: props.onChange }) })] }));
}
function DeliveryPreferencesHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { width: "100%", flexDirection: "row", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.Pen, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: {
                            color: THEME.Text,
                            fontWeight: "500",
                            fontSize: size !== "sm" ? 18 : 16,
                            marginLeft: 12,
                        }, children: props.text }), !!props.subText && ((0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: {
                            color: THEME.Text,
                            fontSize: size !== "sm" ? 14 : 12,
                            marginLeft: 12,
                        }, children: props.subText }))] }), size !== "sm" && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t("common:buttons.close"), hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) }))] }));
}
function TaxDocumentDeliveryMethodCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const w2Electronic = props.w2Electronic;
    const form1095Electronic = props.form1095Electronic;
    const [savingKey, setSavingKey] = react_1.default.useState(null);
    const canEditPreferences = w2Electronic || form1095Electronic;
    const [showEditModal, setShowEditModal] = react_1.default.useState(false);
    const [draftW2Electronic, setDraftW2Electronic] = react_1.default.useState(w2Electronic);
    const [draft1095Electronic, setDraft1095Electronic] = react_1.default.useState(form1095Electronic);
    const [savingPreferences, setSavingPreferences] = react_1.default.useState(false);
    const [modalMode, setModalMode] = react_1.default.useState('edit');
    const [suppressSaveOnAccept, setSuppressSaveOnAccept] = react_1.default.useState(false);
    const updateElection = react_1.default.useCallback(async (type, isElectronic) => {
        setSavingKey(type);
        try {
            const token = await userContext.getToken();
            if (type === "w2") {
                await Taxes_1.default.updateW2Election(token, isElectronic);
                props.onChange({
                    w2Electronic: isElectronic,
                    form1095Electronic: props.form1095Electronic,
                });
            }
            else {
                await Taxes_1.default.update1095CElection(token, isElectronic);
                props.onChange({
                    w2Electronic: props.w2Electronic,
                    form1095Electronic: isElectronic,
                });
            }
            FirebaseAnalytics_1.default.LogEvent("feature_used", {
                feature: `Tax Document Delivery Method - ${type}`,
                client: userContext.client?.id,
                employee: userContext.employee?.employeeId,
                isElectronic,
            });
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                type: "success",
                message: t("myPay:messages.deliveryMethodSaved"),
            });
        }
        catch {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                type: "error",
                message: t("myPay:messages.deliveryMethodFailed"),
            });
        }
        finally {
            setSavingKey(null);
        }
    }, [
        t,
        userContext,
        props.w2Electronic,
        props.form1095Electronic,
        props.onChange,
    ]);
    const openEditModal = react_1.default.useCallback(() => {
        setModalMode('edit');
        setSuppressSaveOnAccept(true);
        setDraftW2Electronic(w2Electronic);
        setDraft1095Electronic(form1095Electronic);
        setShowEditModal(true);
    }, [w2Electronic, form1095Electronic]);
    const savePreferences = react_1.default.useCallback(async () => {
        setSavingPreferences(true);
        try {
            const token = await userContext.getToken();
            const updates = [];
            if (draftW2Electronic !== w2Electronic) {
                updates.push(Taxes_1.default.updateW2Election(token, draftW2Electronic));
            }
            if (draft1095Electronic !== form1095Electronic) {
                updates.push(Taxes_1.default.update1095CElection(token, draft1095Electronic));
            }
            await Promise.all(updates);
            const nextDeliveryState = {
                w2Electronic: draftW2Electronic,
                form1095Electronic: draft1095Electronic,
            };
            setShowEditModal(false);
            setTimeout(() => {
                props.onChange(nextDeliveryState);
            }, react_native_1.Platform.OS === "ios" ? 350 : 0);
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                type: "success",
                message: t("myPay:messages.deliveryMethodSaved"),
            });
        }
        catch {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                type: "error",
                message: t("myPay:messages.deliveryMethodFailed"),
            });
        }
        finally {
            setSavingPreferences(false);
        }
    }, [
        userContext,
        t,
        w2Electronic,
        form1095Electronic,
        draftW2Electronic,
        draft1095Electronic,
        props.onChange,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t("myPay:text.taxDocumentDeliveryMethod"), style: { marginBottom: 8 }, children: canEditPreferences && ((0, jsx_runtime_1.jsxs)(Button_1.default, { type: "outline", onPress: openEditModal, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: "500", marginHorizontal: 6 }, children: t("common:buttons.edit") }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Pen, size: 14, style: { marginRight: 6 } })] })) }), (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { children: [(0, jsx_runtime_1.jsx)(DeliveryRow, { label: t("myPay:labels.W2"), isElectronic: w2Electronic, busy: savingKey === "w2", descriptionWhenPaper: t("myPay:text.w2PaperlessDescription"), descriptionWhenElectronic: t("myPay:text.w2ElectronicDescription"), onAcceptElectronic: () => {
                                    setModalMode('disclosure');
                                    setShowEditModal(true);
                                }, acceptText: t("common:buttons.enroll") }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalDivider }), (0, jsx_runtime_1.jsx)(DeliveryRow, { label: t("myPay:labels.1095C"), isElectronic: form1095Electronic, busy: savingKey === "1095", descriptionWhenPaper: t("myPay:text.1095CPaperlessDescription"), descriptionWhenElectronic: t("myPay:text.1095CElectronicDescription"), onAcceptElectronic: () => {
                                    updateElection("1095", true);
                                }, acceptText: t("common:buttons.enroll") })] })] }), (0, jsx_runtime_1.jsxs)(PlatformModal_1.default, { isVisible: showEditModal, onDismiss: () => setShowEditModal(false), children: [modalMode === 'edit' &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.modalCard, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalHeader, children: (0, jsx_runtime_1.jsx)(DeliveryPreferencesHeader, { text: t("myPay:text.editDeliveryPreferences"), onClose: () => setShowEditModal(false) }) }), (0, jsx_runtime_1.jsx)(PreferenceModalRow, { label: t("myPay:text.w2TaxForm"), mobileLabel: t("myPay:labels.W2"), value: draftW2Electronic, onChange: (value) => {
                                        if (value === true)
                                            setModalMode('disclosure');
                                        setDraftW2Electronic(value);
                                    } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalDivider }), (0, jsx_runtime_1.jsx)(PreferenceModalRow, { label: t("myPay:text.1095CHealthCoverageForm"), mobileLabel: t("myPay:labels.1095C"), value: draft1095Electronic, onChange: setDraft1095Electronic }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.modalActions, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t("common:buttons.cancel"), disabled: savingPreferences, onPress: () => {
                                                    setSuppressSaveOnAccept(false);
                                                    setShowEditModal(false);
                                                } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.modalButtonSpacer }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", text: t("myPay:buttons.savePreferences"), disabled: savingPreferences, onPress: () => {
                                                    setSuppressSaveOnAccept(false);
                                                    savePreferences();
                                                } }) })] })] }), modalMode === 'disclosure' &&
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { width: "100%", flexDirection: "row", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.Memo, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: {
                                                    color: THEME.Text,
                                                    fontWeight: "500",
                                                    fontSize: size !== "sm" ? 18 : 16,
                                                    marginLeft: 12,
                                                }, children: t('myPay:text.electronicDeliveryDisclosureTitle') }) }), size !== "sm" && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t("common:buttons.close"), hitSlop: 12, type: "borderless", onPress: () => setShowEditModal(false), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) }))] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: 'stretch', flexDirection: 'column', alignContent: 'center', maxWidth: react_native_1.Platform.OS === 'web' ? 560 : '100%', width: '100%' }, children: [(0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1, marginBottom: 24, marginTop: 16 }, children: [(0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { fontWeight: 500, fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: [t('myPay:labels.electronicDeliveryDisclosureLabel'), ":\u00A0"] }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: t('myPay:messages.electronicDeliveryDisclosure') })] }), (0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1, marginBottom: 8 }, children: [(0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { fontWeight: 500, fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: [t('myPay:labels.electronicPreferenceDisclosureLabel'), ":\u00A0"] }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: t('myPay:messages.electronicPreferenceDisclosureDelivery') })] }), (0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1, fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14, marginLeft: 16 }, children: ["\u2022\u00A0", t('myPay:messages.electronicPreferenceDisclosureInElevate')] }), (0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1, fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14, marginBottom: 8, marginLeft: 16 }, children: ["\u2022\u00A0", t('myPay:messages.electronicPreferenceDisclosureContact')] }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1, fontSize: Helper_1.Helper.isPlatformWeb ? 14 : 12, marginBottom: 24 }, children: t('myPay:messages.electronicPreferenceDisclosureAmendment') }), (0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1, marginBottom: 24 }, children: [(0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { fontWeight: 500, fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: [t('myPay:labels.electronicChangesDisclosureLabel'), ":\u00A0"] }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: t('myPay:messages.electronicPreferenceDisclosureChanges') })] }), (0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_paper_1.Text, { style: { fontWeight: 500, fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: [t('myPay:labels.electronicRequirementsDisclosureLabel'), ":\u00A0"] }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { fontSize: Helper_1.Helper.isPlatformWeb ? 16 : 14 }, children: t('myPay:messages.electronicRequirementsDisclosure') })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignContent: 'space-evenly', width: '100%', flexDirection: 'row', alignItems: 'center', marginBottom: 8, marginTop: 24, gap: 12 }, children: [(0, jsx_runtime_1.jsx)(Button_1.default, { style: { flex: 1 }, type: "outline", text: t('common:buttons.cancel'), textSize: 14, onPress: () => {
                                                        if (suppressSaveOnAccept) {
                                                            setModalMode('edit');
                                                            setDraftW2Electronic(false);
                                                            return;
                                                        }
                                                        setDraftW2Electronic(false);
                                                        setShowEditModal(false);
                                                    } }), (0, jsx_runtime_1.jsx)(Button_1.default, { style: { flex: 1 }, type: "solid", text: t('common:buttons.accept'), textSize: 14, onPress: () => {
                                                        if (suppressSaveOnAccept) {
                                                            setModalMode('edit');
                                                            setDraftW2Electronic(true);
                                                            return;
                                                        }
                                                        setDraftW2Electronic(true);
                                                        updateElection("w2", true);
                                                        setShowEditModal(false);
                                                    } })] })] })] })] })] }));
}
